// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__nS4I9","searchIcon":"styles_searchIcon__1E4S0","inputRoot":"styles_inputRoot__2j8HB","inputInput":"styles_inputInput__3GEy2"};